import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import i18n from './i18n/i18n';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import RequestRidePage from './pages/RequestRidePage';
import CaptainDashboard from './pages/CaptainDashboard';
import PerformanceReport from './pages/PerformanceReport';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { CircularProgress, Box } from '@mui/material';
import ProfilePage from './pages/ProfilePage';
import { requestPermission, listenForMessages, initFirebase } from './firebase';

const GOOGLE_CLIENT_ID = '814241085797-327krnr2g1r2uhuaiv2qgoi04cb3ujrm.apps.googleusercontent.com';

// تهيئة Firebase (سيتم التهيئة الفعلية من index.html)
initFirebase();

const AppWithTheme = () => {
  const { theme } = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.id) {
      const setupNotifications = async () => {
        try {
          console.log('🔔 [FCM] جاري إعداد الإشعارات للمستخدم:', user.id);
          const token = await requestPermission();
          if (token) {
            console.log('✅ [FCM] Token جاهز للاستخدام في الواجهة');
          } else {
            console.log('⚠️ [FCM] لم يتم الحصول على Token');
          }
        } catch (error) {
          console.error('❌ [FCM] خطأ في إعداد الإشعارات:', error);
        }
      };
      
      setupNotifications();
      
      listenForMessages((notification) => {
        console.log('📨 إشعار ورد:', notification);
      });
    }
  }, [user]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Router>
          <Suspense fallback={
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
              <CircularProgress />
            </Box>
          }>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/request-ride" element={
                <ProtectedRoute>
                  <RequestRidePage />
                </ProtectedRoute>
              } />
              <Route path="/captain" element={
                <ProtectedRoute>
                  <CaptainDashboard />
                </ProtectedRoute>
              } />
              <Route path="/performance" element={
                <ProtectedRoute>
                  <PerformanceReport />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
            </Routes>
          </Suspense>
        </Router>
      </GoogleOAuthProvider>
    </MuiThemeProvider>
  );
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AuthProvider>
          <AppWithTheme />
        </AuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;